import { AppBar, Toolbar, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import "../../Assets/Scss/Header_Page.scss";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import { allNotificationsURL } from "../../Library/URLs";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailIcon from "@mui/icons-material/Mail";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { styled, alpha } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import ImageIcon from "@mui/icons-material/Image";
import { useEffect, useState } from "react";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Notification from "./Notification";
import SearchSuggest from "./SearchSuggest";
import Select from "react-select";
import { LogOut } from "../../store/actions";
import { BsArrowLeft } from "react-icons/bs";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));
const settings = ["Profile", "Account", "Dashboard", "Logout"];

const HeaderContainer = ({ Click }) => {
  const User = useSelector((state) => state.payroll.User);
  const unique_id = uuid();
  const currentUrl = useLocation().pathname;
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openNotification, setOpenNotification] = useState(null);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [suggestions, setSuggestions] = useState(false);
  const [query, setQuery] = useState("");
  const [anchorInitial, setAnchorInitial] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpen = (e) => {
    setOpenNotification(e.currentTarget);
  };

  const handleClose = () => {
    setOpenNotification(null);
  };

  const openInital = Boolean(anchorInitial);
  const handleClickInitial = (event) => {
    setAnchorInitial(event.currentTarget);
  };
  const handleCloseInitial = () => {
    setAnchorInitial(null);
  };

  const handleLogOut = () => {
    setAnchorInitial(null);
    dispatch(LogOut());
    navigate("/");
  };

  // useEffect(() => {
  //   FetchNotifications();
  // }, [currentUrl]);

  // const FetchNotifications = async () => {
  //   const data = {
  //     user_id: User?.id,
  //     user_ses_id: User?.user_ses_id,
  //     transaction_id: unique_id,
  //     company_id: User?.company_id,
  //   };
  //   setIsLoading(true);
  //   await axios
  //     .post(allNotificationsURL, data)
  //     .then((res) => {
  //       setIsLoading(false);
  //       if (res.data.success === true) {
  //         setNotifications(res.data.data);
  //         // console.log('all depart',res.data)
  //       }
  //       // console.log('all department res',res.data)
  //     })
  //     .catch((err) => {
  //       // console.log('Get all department error',err.message)
  //       setIsLoading(false);
  //     });
  // };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const theme = window.localStorage.getItem("theme");

  const locate = useLocation();

  useEffect(() => {}, [theme]);

  return (
    <div className="HeaderBar">
      {suggestions && (
        <div
          className="closeSuggest"
          onClick={() => setSuggestions(false)}
        ></div>
      )}

      <div className="Top_left">
        <button
          className="Nav_Back"
          onClick={() => navigate(-1)}
          style={{
            display:
              (locate.pathname === "/dashboard" ||
                locate.pathname === "employee-dashboard") &&
              "none",
          }}
        >
          <BsArrowLeft />
        </button>
        {/* <div className="Search_Wrap">
          <SearchOutlinedIcon />
          <input
            type="search"
            name="query"
            placeholder="Search…"
            id=""
            onChange={(e) => setQuery(e.target.value)}
            onFocus={() => setSuggestions(true)}
          />
          {suggestions && (
            <SearchSuggest query={query} close={() => setSuggestions(false)} />
          )}
        </div> */}
      </div>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <div className="Circle">
          <IconButton onClick={handleOpen}>
            <Badge
              color="info"
              badgeContent={notifications?.length}
              max={99}
              invisible={isLoading}
            >
              <NotificationsNoneOutlinedIcon
                style={{ color: "rgb(0,0,0,0.5)" }}
                onCl
              />
            </Badge>
          </IconButton>
          <Notification
            open={openNotification}
            onClose={handleClose}
            FetchNotifications={()=>{}}
            notifications={notifications}
            isLoading={isLoading}
          />
        </div>
        <>
          <div
            className="Circle"
            style={{ backgroundColor: theme ? theme : "#13ABF4" }}
          >
            <IconButton
              sx={{ color: "#FFF" }}
              id="initals-button"
              aria-controls={openInital ? "initals-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openInital ? "true" : undefined}
              onClick={handleClickInitial}
            >
              {User ? User?.name[0] : ""}
            </IconButton>
          </div>
          <Menu
            id="initials-menu"
            anchorEl={anchorInitial}
            open={openInital}
            onClose={handleCloseInitial}
            MenuListProps={{
              "aria-labelledby": "initials-button",
            }}
          >
            <MenuItem sx={{ width: 140 }} onClick={handleLogOut}>
              Logout
            </MenuItem>
          </Menu>
        </>
        <IconButton
          className="Menu"
          size="small"
          edge="end"
          aria-label="open drawer"
          onClick={Click}
          color="#fff"
          sx={{ mr: 0, display: { md: "none", sm: "flex" } }}
        >
          <MenuIcon />
        </IconButton>
        <Menu
          sx={{ mt: "45px" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          {settings.map((setting) => (
            <MenuItem key={setting} onClick={handleCloseUserMenu}>
              <Typography textAlign="center">{setting}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>
    </div>
  );
};

export default HeaderContainer;
